import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const mcpConnectionsService = {
    list,
    revoke,
};

function list(accountId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/accounts/${accountId}/mcp-connections`, requestOptions).then(handleResponse);
}

function revoke(accountId, authorizationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(
        `${BASE_URL}api/accounts/${accountId}/mcp-connections/${encodeURIComponent(authorizationId)}/revoke`,
        requestOptions,
    ).then(handleResponse);
}
